// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5iJFf","image":"Header_image__3xYm-","name":"Header_name__2D05W","info":"Header_info__3cuzl","infoRow":"Header_infoRow__3cC3g"};